import { createContext } from 'react';
import utils from 'utils';
import {
  DataRoomNodeAccessState,
  DataRoomNodeWithStateAndSignal,
} from 'models/Lead';

export type FileAccessPopupState = {
  state: DataRoomNodeAccessState;
  nodes: DataRoomNodeWithStateAndSignal[];
};

type DisplayFilesByLeadPopupContextValue = {
  getPopupState: (leadId: string) => FileAccessPopupState;
  setPopupState: (leadId: string, next: FileAccessPopupState) => void;
};

export default createContext<DisplayFilesByLeadPopupContextValue>({
  getPopupState: utils.noop,
  setPopupState: utils.noop,
});
